import Pic from '../images/FaqCut.jpeg';
import './faq.css';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';

function Faq(){
    const schemaData = {
        "@context": "https://schema.org",
        "@type" : "FAQPage",
        "lastReviewed" : "09/02/20226",
        "mainContentOfPage" : "h1",
        "primaryImageOfPage" : "Image of frequently asked questions",
        "reviewedBy": "L.H.",
        "isFamilyFriendly" : "true",
        "about": "Frequently asked questions",
        "aurthor" : "L.H."

    }
    return(
        <>
        <title>Frequently asked questions</title>
        <meta name="description" content="A list of common questions" />
        
        <Image src={Pic} alt="Frequently asked image" id="faqHeaderImage"/>
      
        <h1>FAQ's</h1>
        <p id="subheader">Find answers to frenquently answered questions</p>
        <Container>
            <h2>General & Growing Practices</h2>
            <ul>
                <li>
                   <b> Where is Holistic Green Things located?</b>
                   <p>We are a local urban farm and kitchen operating right here in the Tucson Metro Area.</p>
                </li>
                <li>
                    <b>How are your microgreens grown?</b>
                    <p>Our microgreens are grown in a controled environment, using organic methods</p>
                </li>
                <li>
                    <b>How are your mushrooms grown?</b>
                    <p>Our mushrooms are grown in a controled environment, using orgainc methods</p>
                </li>
                <li>
                    <b>What products do you offer besides microgreens?</b>
                    <p>Alongside our fresh microgreens and gourmet mushrooms, our local farm kitchen crafts small-batch fresh pasta,
                        homemade artisan breads, vegan butter, sunflower pesto, and pet safe wheat grass.</p>
                </li>
            </ul>    
            <h2>
                Home Delivery
            </h2>
            <ul>
                <li>
                    <b>What areas in Tucson do you deliver to?</b>
                    <p>We deliver across the Tucson Metro Area, Rita Ranch, Vail, North West Tucson Sabino Canyon, Bear Canyon.</p>
                </li>
                <li>
                    <b>Will you be delivering outside of your current delivery areas?</b>
                    <p>We hope to be servicing more areas in the near future</p>
                </li>
                <li>
                    <b>When are home deliveries made, and what is the order deadline?</b>
                    <p>Home deliveries are only made on Mondays at this time. You must have your order in by Thursday 12 P.M.</p>
                </li>
                <li>
                    <b>How much does home delivery cost?</b>
                    <p>Delivery is FREE on orders with any active weekly subscription. All other orders will have a flat $5.00 delivery fee.</p>
                </li>
                <li>
                    <b>Do I need to be home to receive my delivery?</b>
                    <p>
                        No! Leave a clean cooler with an ice pack or gel pack on your front porch, and our driver will store your perishable items safely inside to keep them chilled.
                    </p>
                </li>    
            </ul>
            <h2>
                Farmers Market Pick-Ups & Subscriptions
            </h2>
            <ul>
                <li>
                    <b></b>
                    <p>Select "Market Pick-Up" at checkout and choose your location 
                        (e.g., Old Vail Rd, Speedway). Place market pre-orders by Thursday at 5:00 PM to 
                        guarantee your items are reserved.</p>
                </li>
                <li>
                    <b>Can I pause or skip a week on my subscription?</b>
                    <p>Yes. Log into your account before our Thursday 12:00 PM cutoff to pause, skip, or modify your weekly order hassle-free.</p>
                </li>
            </ul>
        </Container>        

        </>
    )
}

export default Faq;